import React from 'react';
import ReactDOM from 'react-dom/client';
import OmegaBookingApp from './App';
import { Helmet } from 'react-helmet';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <OmegaBookingApp />
    <Helmet>
      <title>NTA Omega</title>
      <meta name="description" content="NTA Omega booking system" />
    </Helmet>
  </React.StrictMode>,
);
